import { render, staticRenderFns } from "./newSite.vue?vue&type=template&id=55051261&scoped=true"
import script from "./newSite.vue?vue&type=script&lang=js"
export * from "./newSite.vue?vue&type=script&lang=js"
import style0 from "./newSite.vue?vue&type=style&index=0&id=55051261&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55051261",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55051261')) {
      api.createRecord('55051261', component.options)
    } else {
      api.reload('55051261', component.options)
    }
    module.hot.accept("./newSite.vue?vue&type=template&id=55051261&scoped=true", function () {
      api.rerender('55051261', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/basicData/siteManagement/component/newSite.vue"
export default component.exports